const baseUrl = "https://s3.ap-south-1.amazonaws.com/greentiger.in-content";
const Images = {
  brand_logo: `${baseUrl}/brand_icons/logo.png`,
  logo_tiger: `${baseUrl}/brand_icons/logo_tiger.png`,
};
export default Images;
